const INITIAL_STATE = {
  items: {},
};

module.exports = function TradingReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_LANGUAGE': {
      return {
        ...state,
        items: Object.keys(state.items).reduce(
          (items, itemKey) =>
            (state.items[itemKey] || {}).lastSuccessfulFetch
              ? {
                  ...items,
                  [itemKey]: {
                    ...state.items[itemKey],
                    didInvalidate: true,
                  },
                }
              : items,
          {},
        ),
      };
    }
    case 'FETCH_TRADING_CAMPAIGN_IN_PROGRESS': {
      return {
        ...state,
        items: {
          ...state.items,
          [action.campaignId]: {
            ...(state.items[action.campaignId] || {}),
            fetchingInProgressSince: action.timestamp,
          },
        },
      };
    }
    case 'FETCH_TRADING_CAMPAIGN_SUCCESSFUL':
      return {
        ...state,
        items: {
          ...state.items,
          [action.tradingCampaign._id]: {
            ...action.tradingCampaign,
            fetchingInProgressSince: null,
            didInvalidate: false,
            lastSuccessfulFetch: action.timestamp,
          },
        },
      };
    case 'FETCH_TRADING_CAMPAIGN_FAILED': {
      let key;
      if (action.reason.status === 404) {
        [key] =
          Object.entries(state.items).find(
            ([, campaignEntry]) => campaignEntry.urlAlias === action.campaignId,
          ) || [];
      }
      const { [key]: campaignToDelete, ...items } = state.items;
      return {
        ...state,
        items: {
          ...items,
          [action.campaignId]: {
            ...(state.items[action.campaignId] || {}),
            fetchingInProgressSince: null,
            lastFailedFetch: action.timestamp,
            lastErrorMessage: action.reason,
          },
        },
      };
    }
    default:
      return state;
  }
};
